import React from 'react';
import { Link } from 'react-router-dom';
import Title from 'components/text/Title';
import Subtitle from 'components/text/Subtitle';
// import Logo from 'components/common/Logo';
import styled from 'styled-components';
import EnrollForm from 'components/forms/EnrollForm';

const ExpiredTokenMessage = () => (
  <div className="auth-page-container">
    <div
      style={{
        width: 500,
        maxWidth: '100%',
        margin: 'auto',
        textAlign: 'center',
      }}
    >
      <AuthLogoContainer>{/* <Logo /> */}</AuthLogoContainer>
      <div>
        <Title>
          Hmm.... we had some trouble with your cclariti invite. <br />
          But that's okay.
        </Title>
        <Subtitle>
          Try the "forgot my password" form <strong> using the email you were invited to cclariti</strong> with?
          <br />
          You can get to the form <Link to="/forgot-password">here</Link>. Thanks!
        </Subtitle>
      </div>
    </div>
  </div>
);

// STYLED-COMPONENTS
// ========================================
const AuthLogoContainer = styled.div`
  text-align: center;
  height: 135px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

class EnrollAccount extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      token: this.props.match.params.token,
      expiredToken: false,
    };
  }

  onExpiredToken = () => {
    this.setState({ expiredToken: true });
  };

  render() {
    if (this.state.expiredToken) {
      return <ExpiredTokenMessage />;
    }

    return (
      <div style={{ maxWidth: '100%' }}>
        <div style={{ width: 400, maxWidth: '95%', margin: 'auto' }}>
          <AuthLogoContainer>{/* <Logo /> */}</AuthLogoContainer>
          <div>
            <Title style={{ textAlign: 'center' }}>Welcome! Please set your password.</Title>
            <EnrollForm onExpiredToken={this.onExpiredToken} token={this.state.token} {...this.props} />
          </div>
        </div>
      </div>
    );
  }
}

export default EnrollAccount;



// WEBPACK FOOTER //
// ./src/routes/auth-enroll-account/index.js